/**
 * Slice 17g — resolve the poster URL for a `media_type='video'` indexed-card
 * tile. Prefers the durable Supabase Storage `variant='thumbnail'` row over the
 * platform CDN URL on the post itself.
 *
 * Pure function. No I/O. Used by `AdsAssistantAggregationPostRow` when building
 * the `postThumbnailUrl` prop for `AdsAssistantPostMediaStrip` (Slice 17f-D
 * video tile).
 *
 * Fallback chain (matches Slice 17f-D's plan):
 *   1. First `post.post_media[i]` where `variant === "thumbnail"` and
 *      `signed_url` is a non-empty string → return its `signed_url`.
 *   2. `post.thumbnail_url` (raw platform CDN URL) when non-empty.
 *   3. `null` — caller renders the neutral "Video" placeholder tile.
 */
import type { AdsAssistantSocialPostRow } from "@/lib/adsAssistantClientTypes";

export function resolveAdsVideoPosterUrl(post: AdsAssistantSocialPostRow): string | null {
  const mediaRows = Array.isArray(post.post_media) ? post.post_media : [];
  for (const row of mediaRows) {
    if (!row) continue;
    if (row.variant !== "thumbnail") continue;
    const signed = row.signed_url;
    if (typeof signed !== "string") continue;
    const trimmed = signed.trim();
    if (!trimmed) continue;
    return trimmed;
  }
  if (typeof post.thumbnail_url === "string" && post.thumbnail_url.trim()) {
    return post.thumbnail_url;
  }
  return null;
}
